import usersUpdateComponent from './users-update.component';

const usersUpdateModule = angular
  .module('usersUpdate', [])
  .component('usersUpdate', usersUpdateComponent);

export default usersUpdateModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/users/users-update/users-update.js
 **/